import { isValidURL } from 'components/editor/helpers/InputValidation';
import type { ProspectOption } from 'components/editor/SidePanel/DocumentSettings/useProspect';

export const FIELD_MAX_LENGTH = 255;

export const containsEmoji = (value: string): boolean => /\p{Extended_Pictographic}/u.test(value);

export const isFieldLengthValid = (value: string, maxLength = FIELD_MAX_LENGTH): boolean => value.length <= maxLength;

export const isWebsiteUrlValid = (url: string): boolean => url === '' || isValidURL(url);

export const isRequiredFieldValid = (value: string): boolean => Boolean(value.trim());

export const isNameValid = (name: string, prospectOptions: ProspectOption[] = []): boolean => {
  const trimmedName = name.trim();
  if (!isRequiredFieldValid(trimmedName)) return false;

  return !prospectOptions.some((option) => option.label.trim().toLowerCase() === trimmedName.toLowerCase());
};

export const getMaxLengthErrorMessage = (t: (key: string) => string): string =>
  t('document.create_company.notification.errors.max_length_error');

export const getEmojiErrorMessage = (t: (key: string) => string): string =>
  t('document.create_company.notification.errors.emoji_not_allowed');

export const getRequiredFieldErrorMessage = (t: (key: string) => string): string =>
  t('document.create_company.notification.errors.required_field');

export const getInvalidEmailErrorMessage = (t: (key: string) => string): string => t('document_invite.form.invalid_email');

export const getDuplicateEmailErrorMessage = (t: (key: string) => string): string =>
  t('document.create_contact.notification.errors.duplicate_email');

export const getInvalidPhoneErrorMessage = (t: (key: string) => string): string =>
  t('document.create_contact.notification.errors.invalid_phone_number');

export const getInvalidUrlErrorMessage = (t: (key: string) => string): string => t('document.grid.video.design.errors.invalid_url');

export const normalizeWebsiteUrl = (value: string): string => {
  const trimmed = value.trim();
  if (trimmed && !trimmed.startsWith('http://') && !trimmed.startsWith('https://')) {
    return `https://${trimmed}`;
  }
  return trimmed;
};

export const getDuplicateCompanyErrorMessage = (t: (key: string) => string): string =>
  t('document.create_company.notification.errors.duplicate_company_error');
